import type {
  Data, Cache, UpdatesConfig, Variables,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';
import { updateSchoolCache } from './updateImplementationsCache';

const schoolMutation: UpdatesConfig['Mutation'] = {
  schoolOverviewUpdate: (_: Data, vars: Variables, cache: Cache) => {
    updateSchoolCache(cache, vars.id as number);
    invalidateQuery('rentersImplementation', cache);
    invalidateQuery('tuitionImplementation', cache);
  },
  schoolSignRenters: (_: Data, vars: Variables, cache: Cache) => {
    updateSchoolCache(cache, vars.id as number);
    invalidateQuery('rentersImplementation', cache);
  },
  schoolSignTuition: (_: Data, vars: Variables, cache: Cache) => {
    updateSchoolCache(cache, vars.id as number);
    invalidateQuery('tuitionImplementation', cache);
  },
};

export default schoolMutation;
